import $ from 'jquery'
import '../configuration/sweetalert'

window.$ = window.jQuery = $
